import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "table-card" }
const _hoisted_3 = { class: "row-num" }
const _hoisted_4 = { class: "cell-text" }
const _hoisted_5 = { class: "cell-meta" }
const _hoisted_6 = { class: "cell-price" }
const _hoisted_7 = { class: "cell-price actual" }
const _hoisted_8 = { class: "cell-time" }

import { ref, onMounted } from 'vue'
import { HttpManager } from '@/api'
import CustomPagination from '@/components/common/CustomPagination.vue'

const loadingSvg = `
  <svg xmlns="http://www.w3.org/2000/svg">
    <image href="/20250706Logo.png" width="45" height="45" x="7" y="7" preserveAspectRatio="xMidYMid meet"/>
  </svg>
`;


export default /*@__PURE__*/_defineComponent({
  __name: 'PayRecord',
  setup(__props) {

const payRecords = ref([])
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)
const loading = ref(false)

const fetchPayRecords = async () => {
  loading.value = true
  try {
    const response = await HttpManager.getLoginUserPayInfoPage({
      page: currentPage.value,
      size: pageSize.value
    })
    payRecords.value = response.data.data
    total.value = response.data.total
  } catch (error) {
    console.error('获取支付记录失败:', error)
  } finally {
    loading.value = false
  }
}

const handlePaginationChange = (page: number, size: number) => {
  currentPage.value = page
  pageSize.value = size
  fetchPayRecords()
}

onMounted(() => { fetchPayRecords() })

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "page-header" }, [
      _createElementVNode("h2", { class: "page-title" }, "支付记录")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        "element-loading-text": "加载中...",
        "element-loading-background": "rgba(0, 0, 0, 0.8)",
        "element-loading-svg-view-box": "-10, -10, 80, 80",
        "element-loading-svg": loadingSvg,
        data: payRecords.value,
        class: "data-table",
        "empty-text": "暂无支付记录"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "#",
            width: "60",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_3, _toDisplayString((currentPage.value - 1) * pageSize.value + scope.$index + 1), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "订单编号",
            "min-width": "280",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(scope.row.orderCode), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "商品名称",
            "min-width": "180",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_5, _toDisplayString(scope.row.titleName || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "类型",
            width: "110",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                class: _normalizeClass(["cell-tag", scope.row.payBizType === '00' ? 'song' : 'vip'])
              }, _toDisplayString(scope.row.payBizType === '00' ? '歌曲购买' : '会员购买'), 3)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "应付",
            width: "100",
            align: "right"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_6, "¥" + _toDisplayString(scope.row.payAmount), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "实付",
            width: "100",
            align: "right"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_7, "¥" + _toDisplayString(scope.row.actualPayAmount), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "支付时间",
            "min-width": "170"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_8, _toDisplayString(scope.row.callbackTime), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, loading.value]
      ]),
      _createVNode(CustomPagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
        total: total.value,
        "page-size-options": [10, 20, 30, 50],
        onChange: handlePaginationChange
      }, null, 8, ["current-page", "page-size", "total"])
    ])
  ]))
}
}

})